module.exports = __webpack_public_path__ + "img/list-empty.1f29b3bd.png";